// Dane changelogu - wersje + planowane zmiany
// Używane przez komponent Changelog.jsx

export const VERSIONS = [
  {
    version: '0.5',
    date: '2026-06-02',
    status: 'current',
    title: 'Maria — sprzątanie z oknem czasowym, import Booking.com',
    summary: 'Maria widzi blok Teraz/Aktywna checklista/Plan sprzątań i potwierdza zadania przyciskiem Widziałam. Import Booking.com zapisuje guest_count i guest_details.',
    sections: [
      {
        type: 'added',
        items: [
          'Zdjęcia paragonów przy zakupach: mobilny upload, miniatury, endpoint GET /api/receipts/{filename}',
          'Godziny checkin_time (15:00) i checkout_time (11:00) w rezerwacjach',
          'Endpoint PATCH /api/cleaning-jobs/{id}/acknowledge z polami acknowledged_by_staff / acknowledged_at',
          'Backend wylicza availability_status, is_current_action, is_checklist_enabled',
          'Import Booking.com zapisuje guest_count i guest_details ("2 dorosłych, 2 dzieci (0,3)")',
        ],
      },
      {
        type: 'changed',
        items: [
          'Maria zarządza jednym aktywnym sprzątaniem; przyszłe są zablokowane',
          'Sprzątanie dostępne w oknie checkout → checkin (np. 11:00–15:00)',
          'Panel /sprzatanie: uproszczony widok harmonogramu zamiast tabeli',
        ],
      },
      {
        type: 'security',
        items: [
          'Maria nie może rozpocząć przyszłego/niekolejnego sprzątania (403)',
          'Maria nie może zakończyć sprzątania, którego nie rozpoczęła',
        ],
      },
    ],
  },
  {
    version: '0.4',
    date: '2026-06-01',
    status: 'past',
    title: 'Stabilizacja portalu, użyteczne nagłówki, naprawy routingu',
    summary: 'Ujednolicone PageHeader, poprawki routingu SPA, dashboard operacyjny, panel Marii.',
    sections: [
      {
        type: 'fixed',
        items: [
          'Routing SPA — usunięty zduplikowany <BrowserRouter>',
          'Brakujący import Outlet w AppLayout.jsx',
          'Konflikt portu 3000 z whatsapp-bridge — frontend na 3010',
          'Brakujący endpoint GET /api/bookings/{ref} (404 → 200)',
          'Błędy JSX: "e is not a function" w Login, "Cannot read filter" w Dashboard, "Cannot read role" w Reservations',
          'CMD w Dockerfile frontend — "vite dev" → "vite preview" (build + serve)',
        ],
      },
      {
        type: 'added',
        items: [
          'Komponent PageHeader (ikona, opis, statystyki, akcje, breadcrumbs)',
          'Nagłówki na wszystkich widokach + breadcrumbs w szczegółach rezerwacji',
          'Strona /zmiany z changelogiem (ta strona)',
          'Endpoint GET /api/bookings/{ref} dla ID i external_id + testy test_get_booking_by_id / _by_external_id',
          'Dashboard operacyjny: status mieszkania, sprzątanie 100 PLN, zakupy Marii',
          'Panel Marii: liczba gości, pościel/ręczniki dla najbliższego przyjazdu, kontekst rezerwacji w zadaniu',
          'Filtry rezerwacji jednego apartamentu: Teraz, Nadchodzące, Dzisiaj, Do rozliczenia, Historia, Anulowane',
        ],
      },
      {
        type: 'changed',
        items: [
          'Login — minimalistyczny design, karty demo michal/monika/maria',
          'Rezerwacje — usunięto "(X os.)" z nagłówka karty, domyślny widok = aktualne + przyszłe',
          'Dashboard — uproszczony układ, statystyki w PageHeader',
        ],
      },
    ],
  },
  {
    version: '0.3',
    date: '2026-05-31',
    status: 'past',
    title: 'Hermes Gmail Heartbeat',
    summary: 'Cykliczny import rezerwacji z maili Booking.com przez Gmail IMAP + AgentMail.',
    sections: [
      {
        type: 'added',
        items: [
          'hermes-agent-heartbeat worker — cyklicznie sprawdza Gmail i importuje rezerwacje z Booking.com',
          'Endpoint /api/import/email-text + integracja z AgentMail API',
          'Konfiguracja HERMES_API_TOKEN, ENABLE_GMAIL_HEARTBEAT, GMAIL_USER, GMAIL_APP_PASSWORD',
        ],
      },
    ],
  },
  {
    version: '0.2',
    date: '2026-05-31',
    status: 'past',
    title: 'Email/Hermes Import',
    sections: [
      {
        type: 'added',
        items: [
          'Import rezerwacji z tekstu maila Booking.com + komponent EmailImport w UI',
          'Automatyczne tworzenie zadania sprzątania po imporcie',
          'Polskie i ukraińskie tłumaczenia checklisty',
        ],
      },
    ],
  },
  {
    version: '0.1',
    date: '2026-05-30',
    status: 'past',
    title: 'Initial MVP',
    sections: [
      {
        type: 'added',
        items: [
          'FastAPI + SQLite (health, login, bookings, cleaning-jobs, expenses) + React + Vite',
          'Kontenery Docker: backend, frontend, agent-worker (port 3000)',
          'Konta michal/monika (admin), maria (staff, uk) + 16 testów API',
        ],
      },
    ],
  },
];

// Uwaga: status 'next' może być tylko na JEDNEJ pozycji — to ona jest wyróżniona jako „Najbliższe".
export const ROADMAP = [
  {
    version: '0.6',
    title: 'Rezerwacje — edycja i anulowanie w UI',
    status: 'next',
    priority: 'Najbliższe',
    outcome: 'Michał poprawia daty, godziny, liczbę osób i notatki bez ręcznego importu ani grzebania w bazie.',
    items: [
      'Modal edycji rezerwacji: gość, daty, godziny check-in/check-out, liczba osób, notatki',
      'Anulowanie/usunięcie rezerwacji przez admina z czytelnym wpływem na sprzątanie i rachunek',
      'Walidacja dat/godzin przed zapisem i czytelny komunikat błędu',
      'Historia/audyt zmian (kto, kiedy, co)',
    ],
  },
  {
    version: '0.7',
    title: 'Integracje — Booking.com i AgentMail pod kontrolą',
    priority: 'Operacje',
    outcome: 'Import rezerwacji widoczny i odporny: status, ostatni mail, błędy, retry, brak duplikatów.',
    items: [
      'Panel stanu importu: ostatnie sprawdzenie, ostatnia rezerwacja, kolejka błędów',
      'Dedup/retry z logiem dla maili Booking.com i AgentMail',
      'Webhook AgentMail jako tryb natychmiastowy (zamiast samego pollingu)',
      'Alert gdy import/heartbeat przestaje działać lub nie widzi nowych maili',
    ],
  },
  {
    version: '0.8',
    title: 'Zakupy Marii — decyzje i zwroty',
    priority: 'Maria + admin',
    outcome: 'Maria widzi proste statusy, Michał ma kolejkę: do sprawdzenia, do doprecyzowania, do zwrotu, zwrócone.',
    items: [
      'Filtry admina: Czeka / Do doprecyzowania / OK do zwrotu / Zwrócone',
      'Ścieżka decyzji: AI/paragon → Michał → zwrot pieniędzy',
      'Komentarz admina dla Marii przy doprecyzowaniu bez żargonu technicznego',
      'Lepsze wykrywanie duplikatów bez blokowania formularza Marii',
    ],
  },
  {
    version: '0.9',
    title: 'Sprzątanie — prawdziwy kalendarz turnoverów zamiast kolejki rezerwacji',
    priority: 'Stabilizacja',
    outcome: 'Kolejka sprzątania odzwierciedla realną pracę Marii (guest_count, noce, checkout, buffer), a nie linearną oś rezerwacji. Plan i wykonanie są rozdzielone, płatność nie jest flat-rate.',
    items: [
      'Zastąpić „kolejkę" kalendarzem turnoverów (checkout → checkin)',
      'Przenieść do joba realne dane: guest_count, nights, checkout, buffer time, priorytet',
      'Usunąć globalny single-current-action; limit per cleaner/slot',
      'Pokazywać backlog w UI zamiast ukrywać przyszłe zadania',
      'Rozdzielić planowanie, status wykonania i rozliczenie w osobne modele',
      'Przy imporcie rezerwacji aktualizować istniejące joby, nie tylko tworzyć nowe',
    ],
  },
  {
    version: '0.10',
    title: 'Rachunki — przywrócenie automatycznego workera',
    priority: 'Stabilizacja',
    outcome: 'Prośby gości o fakturę/rachunek przechodzą automatycznie przez kolejkę Mateusza bez ręcznego klikania „Wystaw teraz". Operator widzi alarm, gdy kolejka nie rusza dłużej niż 4h.',
    items: [
      'Naprawić BACKEND_URL w docker-compose dla hermes-agent-heartbeat (alias „backend" albo adres backendu w sieci Dockera) — worker odpala się, ale ma Connection refused i nie wystawia żadnych szkiców',
      'Dodać integrację „billing" w portal_integration_run_requests.py, żeby dispatcher minutowy wołał /api/internal/billing/process jako alternatywa dla kontenera heartbeat',
      'Backfill guest_messages.booking_id w process_guest_messages (ID 1245 Bartosz ma booking_id=NULL mimo poprawnej korelacji)',
      'Automatyczny dedup szkiców billing w _maybe_create_billing_draft_from_message po external_booking_id + status IN (draft, queued, error)',
      'Backstop kwot z rozszerzonych źródeł: wzbogacić pulse_phone_watch.py o cenę/method, bo dziś 333/333 snapshotów Pulse nie zawiera PLN/price',
      'Alert (UI + WhatsApp) gdy integration_runs dla billing nie ma wpisu przez 4+ godziny',
    ],
  },
  {
    version: '0.11',
    title: 'Bezpieczeństwo i niezawodność',
    priority: 'Stabilizacja',
    outcome: 'Portal przeżywa restart, sesje wygasają, PIN-y nie leżą jawnym tekstem, jest odtwarzalny backup.',
    items: [
      'Hashowanie PIN-ów + sesje z wygasaniem (zamiast wiecznych tokenów w pamięci procesu)',
      'Twardszy podział ról: staff nie pobiera danych, których nie powinien widzieć',
      'Automatyczny backup SQLite i katalogów uploadów z testem odtworzenia',
      'Ekran zdrowia systemu: backend, frontend, worker, import maili, wolne miejsce',
      'Audit log dla logowań i działań admina',
    ],
  },
  {
    version: '1.0',
    title: 'Raport właścicielski jednego apartamentu',
    priority: 'Raporty',
    outcome: 'Miesięczny obraz: obłożenie, przychody, koszty sprzątania, zakupy i eksport danych.',
    items: [
      'Raport miesiąca: obłożenie, liczba pobytów, przychód, koszty operacyjne',
      'Eksport CSV/PDF: rezerwacje, sprzątania, zakupy i zwroty',
      'Porównanie miesiąc do miesiąca oraz szybkie wskazanie nietypowych kosztów',
      'Multi-apartment zostaje w IDEAS do czasu drugiego realnego mieszkania',
    ],
  },
];

export const IDEAS = [
  'Aplikacja mobilna (PWA z offline mode)',
  'Integracja z kalendarzem (Google Calendar, Apple Calendar)',
  'Faktury dla gości (PDF) — już zrobione w 0.10',
  'Wielojęzyczność UI (PL/UK/EN przełącznik)',
  'Tryb „ciemny" / dark mode',
  'Inwentarz mieszkania — checklista stanowa (ręczniki, papier, środki czystości) odhaczana przez Marię po sprzątaniu; automatyczne alerty o brakach do Michała',
  'Płatność za sprzątanie zależna od realnej pracy (guest_count, noce, buffer), nie flat 100 PLN (z audytu sprzątania 05.06)',
  'Webhook do Sentry / Pushover / Ntfy dla błędów integracji (Pulse, Booking.com, Gmail) zamiast cichego integration_runs.error',
  'Niezależne alerty per integracja (co 30 min, jeśli 3 kolejne runy „error") — żeby P1 z billing workera nie powtórzył się w innej integracji',
  'Gabriel: monitoring rachunków — wiek najstarszego nieprzetworzonego szkicu >4h → alarm (worker Mateusza nie działa)',
  'Gabriel: monitoring sprzątania — przeterminowane joby (scheduled_date < dziś i status != done/cancelled) → alarm',
  'Gabriel: monitoring aktywności Marii — brak logowania >72h → alarm (może nie widzieć zadań)',
  'Gabriel: rozszerzyć EXPECTED_CRON o Pulse watchdog, NUKIangel, AI receipt review i self-check — dziś monitoruje tylko 6/11 cronów',
  'Gabriel: naprawić logikę cooldown — powtarzać ten sam zestaw alertów co 2h, zamiast czekać aż zmieni się fingerprint (błędy wiszą niewysłane od 8h)',
  'Tryb „noc" dla Marii (UI bez chrome po 22:00) — duży przycisk akcji i status sprzątania widoczne z odległości 1 m',
  'Tłumaczenie instrukcji do mieszkania na EN/UK do wysyłki gościom poza Polską',
  'Migracja SQLite → PostgreSQL przed realnym HA (z planu v2)',
  'Rozbicie main.py (4267 linii) na moduły billing, integrations, cleaning, auth',
];
